import React, { useState, useEffect } from 'react';
import { Button, Card, CardBody, CardTitle } from 'reactstrap';
import { getData } from 'RestControllers/Controller';
import { useSede } from 'context/SedeContext';

const TestCoachesEndpoint = () => {
  const [coaches, setCoaches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { addSedeParams, addSedeHeaders } = useSede();

  const testEndpoint = async () => {
    setLoading(true);
    setError(null);
    setCoaches([]);

    try {
      const baseUrl = 'https://revive-back.vercel.app/api/';
      const sedeParams = addSedeParams({});
      const sedeHeaders = addSedeHeaders({});
      
      console.log('Testing coaches endpoint...');
      console.log('URL:', baseUrl + 'accounts/users/coaches/');
      console.log('Sede Params:', sedeParams);
      console.log('Sede Headers:', sedeHeaders);
      
      const response = await getData('GET', baseUrl + 'accounts/users/coaches/', sedeParams, {}, sedeHeaders);
      
      console.log('Response:', response);
      console.log('Response data:', response.data);
      
      setCoaches(response.data || []);
    } catch (err) {
      console.error('Error testing endpoint:', err);
      setError(err.message || 'Error desconocido');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="mb-4">
      <CardBody>
        
        
        <Button 
          color="primary" 
          onClick={testEndpoint} 
          disabled={loading}
          className="mb-3"
        >
          {loading ? 'Probando...' : 'Probar Endpoint'}
        </Button>
        
        {error && (
          <div className="alert alert-danger">
            <strong>Error:</strong> {error}
          </div>
        )}
        
        {coaches.length > 0 && (
          <div className="alert alert-success">
            <strong>Éxito:</strong> Se encontraron {coaches.length} coaches:
            <ul className="mt-2">
              {coaches.map((coach, index) => (
                <li key={index}>
                  {coach.username} - {coach.first_name} {coach.last_name}
                </li>
              ))}
            </ul>
          </div>
        )}
        
        {coaches.length === 0 && !loading && !error && (
          <div className="alert alert-info">
            No hay coaches cargados. Haz clic en "Probar Endpoint" para cargar los datos.
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default TestCoachesEndpoint;
